import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { selectionsSelector, setSelections } from 'redux/slices/selections';

import { selectionDataService } from 'services/selection.service';

import { LayoutContext } from 'contexts';

import { useFetch } from 'hooks';

import { useColumns } from './columns.data';

const useMyLists = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const { breadcrumbSet, breadcrumbSecondarySet } = useContext(LayoutContext);

  const { season, warehouse } = useAppSelector((state) => state.settings);
  const selections = useAppSelector(selectionsSelector.selectAll);

  const [isModalVisible, isModalVisibleSet] = useState(false);

  const { isLoading, content } = useFetch(
    season ? () => selectionDataService.getAll(season, warehouse.code) : undefined,
    [season]
  );

  const columns = useColumns();

  useEffect(() => {
    const breadcrumb = [
      {
        label: t('selection.myLists'),
      },
    ];

    breadcrumbSet(breadcrumb);

    if (season) {
      const breadcrumbSecondary = [
        {
          label: 'Home',
        },
        {
          label: t('selection.myLists'),
        },
      ];

      breadcrumbSecondarySet(breadcrumbSecondary);
    }
  }, [season]);

  useEffect(() => {
    if (content) {
      dispatch(setSelections(content));
    }
  }, [content]);

  return {
    selections,
    isModalVisible,
    isModalVisibleSet,
    columns,
    isLoading,
    t,
  };
};

export { useMyLists };
